var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 47,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.32 7.958A8.167 8.167 0 0058.52 2.12 197.797 197.797 0 0033.001.772 197.797 197.797 0 007.48 2.119 8.167 8.167 0 001.68 7.96 86.852 86.852 0 00.334 23.72 87.466 87.466 0 001.68 39.563 8.166 8.166 0 007.48 45.28 197.778 197.778 0 0033 46.628c8.528.101 17.052-.349 25.521-1.348a8.166 8.166 0 005.799-5.717 87.462 87.462 0 001.347-15.843A86.845 86.845 0 0064.32 7.958zM26.304 33.48V14.043l17.109 9.677-17.11 9.718v.041z",
    fill: "#fff",
    fillOpacity: 0.85
  })));
};
export default SvgYoutube;